import { TOGGLE_DRAWER, SET_DRAWER } from './SideBarDrawerActionType'

export const toggleDrawer = () => ({
  type: TOGGLE_DRAWER
})

export const setDrawer = open => ({
  type: SET_DRAWER,
  payload: open
})
